import React from 'react';
import { DownloadOutlined } from '@ant-design/icons';
import { useDispatch } from 'react-redux';
import { loadDeliveryNoteBlob } from '../../actions/deliveryNotes';
import { uiOpenModalPdf } from '../../actions/uiPdf';

export const BtnDownload = (props) => {

    const dispatch = useDispatch();

    const delivery = {
        store_id: props.delivery?.store_id,
        deliverynote: props.delivery?.deliverynote,
    }

    const handleClick = () => {
        dispatch(loadDeliveryNoteBlob(delivery));
        dispatch(uiOpenModalPdf());
    }

    return (
        <button className="btn btn-danger btn-movement btn-padding" props={props} onClick={handleClick}>
            <DownloadOutlined />
        </button>
    )
}
